import React from 'react';
import { observer, inject } from 'mobx-react';
import { Panel, Row, Col,Button } from 'react-bootstrap';
import PolicyList from './PolicyList';
import AddPolicy from './AddPolicy';


@inject('policyStore')
@observer
export default class Policies extends React.Component {

    render() {
        return (<Panel>
            <Panel.Heading>
                   <Row>
                       <Col lg={10} > <h5>Policies</h5> </Col>
                       <Col lg={2} ><Button bsStyle="primary" onClick={()=>{this.props.policyStore.ToggleAddPolicyModal();}} >Add Policy</Button></Col>
                   </Row>
            </Panel.Heading>
            <Panel.Body>
                <PolicyList />
                <AddPolicy />
            </Panel.Body>
        </Panel>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Policies/index.js